import { render, staticRenderFns } from "./CargoList.vue?vue&type=template&id=e37abf6a&scoped=true"
import script from "./CargoList.vue?vue&type=script&lang=js"
export * from "./CargoList.vue?vue&type=script&lang=js"
import style0 from "./CargoList.vue?vue&type=style&index=0&id=e37abf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37abf6a",
  null
  
)

export default component.exports